var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcDisableCouponDownload = function SvgIcDisableCouponDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M1 18.5c0-.552.407-1 .91-1h16.18c.503 0 .91.448.91 1s-.407 1-.91 1H1.91c-.503 0-.91-.448-.91-1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M9.05 3.143a.953.953 0 1 1 1.905 0v11.422a.953.953 0 0 1-1.905 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M4.033 9.551a.953.953 0 0 1 1.348 0l4.618 4.619 4.618-4.619a.953.953 0 1 1 1.347 1.347l-5.292 5.292a.953.953 0 0 1-1.347 0l-5.292-5.292a.953.953 0 0 1 0-1.347",
    clipRule: "evenodd"
  })));
};
export default SvgIcDisableCouponDownload;